import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/_panel/_core")({
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
